<template>
    <div class="body-container">
        <BannerSection title=" Préstamos con garantía de auto en CDMX"
                       subtitle="Rápido, seguro y sin dejar de usar tu auto" />
        <PerksComponent></PerksComponent>
        <div class="section-container regular-text">
            <div class="position-relative  pb-3 pb-md-0 ">
                <div class="text-container">
                    <h1 class="title"><b>Préstamos con garantía de auto en Ciudad de México (CDMX)</b></h1>
                    <br>
                    <h2 class="h2-title" style="text-align: center;">Obtén liquidez inmediata: dinero rápido y seguro</h2>
                    <br>
                    <p class="regular-text">
                        Ofrecemos una solución financiera que te permite mantener tu movilidad mientras aseguras el
                        capital que necesitas. Nuestros préstamos están diseñados para que obtengas liquidez de forma
                        rápida y sin complicaciones.
                    </p>
                    <p class="regular-text">
                        Aquí te contaremos todo lo que necesitas saber para solicitar uno, asegurarte de hacerlo de
                        manera segura y encontrar las mejores opciones cerca de ti.
                    </p>
                    <br>
                    <span>
                        <h2 class="h2-title"><b>¿Por qué elegirnos?</b></h2>
                    </span>

                    <p class="regular-text">
                        Descubre las razones que nos hacen tu mejor opción para obtener préstamos en CDMX:
                    </p>
                    <ol>
                        <li class="regular-text">
                            <p class="regular-text"><b>Consigue hasta $120.000 en menos de 24 horas</b>. Nuestro proceso
                                ágil garantiza que tengas el dinero cuando más lo necesitas, sin esperas innecesarias.
                            </p>
                        </li>
                        <li class="regular-text">
                            <p class="regular-text"><b>Solicitud completamente en línea.</b> Haz tu solicitud 100% en
                                línea y obtén un préstamo preaprobado en solo 2 minutos. Además, nosotros vamos hasta
                                donde estés para que consigas tu préstamo sin salir de casa.</p>
                        </li>
                        <li class="regular-text">
                            <p class="regular-text"><b>Sigue manejando tu auto mientras pagas el préstamo.</b> A
                                diferencia de los tradicionales empeños CDMX, con nosotros tu auto permanece en tus
                                manos. No tienes que dejarlo en depósito, te proporcionamos la liquidez que necesitas
                                sin sacrificar tu movilidad. </p>
                        </li>
                        <li class="regular-text">
                            <p class="regular-text"><b>Liquida cuando quieras.</b> Puedes pagar tu préstamo en el
                                momento que tú decidas, con una penalización mínima del 1%.
                            </p>
                        </li>
                    </ol>
                    <br>
                    <p class="regular-text">
                        Con nuestra solución de préstamo en la ciudad de México, te ofrecemos una forma segura y
                        confiable de acceder a financiamiento urgente, lo que te permite seguir adelante con tus planes
                        sin interrupciones.
                    </p>

                    <br>
                    <h2 class="h2-title">
                        <b>Proceso simplificado en tres pasos</b>
                    </h2>
                    <p class="regular-text">Nuestro proceso de préstamos personales en la Ciudad de México está diseñado
                        para ser rápido, eficiente y totalmente digital.</p>
                    <ol>
                        <li class=" regular-text">
                            <p class=" regular-text">
                                <b>Completa tu solicitud en línea en solo 2 minutos</b>
                                Ingresa a nuestra plataforma desde cualquier dispositivo con acceso a internet, completa
                                los datos básicos y envía tu solicitud sin complicaciones.

                            </p>
                        </li>
                        <li class=" regular-text">
                            <p class=" regular-text">
                                <b>Recibe pre-aprobación rápida y oferta basada en el valor de tu auto</b>
                                Utilizamos un sistema avanzado para evaluar rápidamente el valor de tu auto y
                                proporcionarte una oferta de préstamo justa y transparente. No necesitas esperar días
                                para saber si estás pre-aprobado.

                            </p>
                        </li>
                        <li class=" regular-text">
                            <p class=" regular-text">
                                <b>Obtén el dinero directamente en tu cuenta bancaria</b>
                                Una vez aprobado el préstamo, recogida la factura y firmado el contrato, el dinero será
                                depositado directamente en tu cuenta bancaria, por lo que podrás acceder a los fondos
                                cuanto antes.
                                Con nuestros empeños CDMX, te proporcionamos no sólo liquidez, sino también la
                                tranquilidad de saber que estás en manos de expertos.
                            </p>
                        </li>
                    </ol>
                </div>
            </div>
        </div>


        <div style="background-color: rgba(255, 165, 0, 0.04); padding: 1.5rem 0rem; margin: 0rem 0rem;">
            <div class="ibancar-election">
                <p>¿Por qué elegir Ibancar?</p>
            </div>
            <BeneficiosIbancarCarousel />
        </div>


        <div class="section-container regular-text">
            <div class="position-relative  pb-3 pb-md-0 ">
                <div class="text-container">
                    <br>
                    <h2 class="h2-title">
                        <b>Requisitos claros y simples</b>
                    </h2>
                    <p class="regular-text">Para garantizar un proceso transparente y sin complicaciones, necesitarás:
                    </p>
                    <ul>
                        <li class="regular-text">
                            <p><b>INE: una copia de tu identificación oficial para verificar tu identidad.</b></p>
                        </li>
                        <li class="regular-text">
                            <p><b>Comprobante de ingresos y domicilio:</b> para confirmar tu estabilidad financiera y
                                residencia actual. </p>
                        </li>
                        <li class="regular-text">
                            <p><b>Documentación del vehículo:</b> necesitaremos la factura original o de refactura, la
                                tarjeta de circulación y fotos recientes del vehículo para evaluar su estado y valor.
                            </p>
                        </li>
                    </ul>
                    <br>
                    <h2 class="h2-title">
                        <b>Condiciones</b>
                    </h2>
                    <ul>
                        <li class="regular-text">
                            <p> <b>Aceptamos clientes con historial en Buró de crédito:</b> no permitimos que un
                                historial crediticio desfavorable sea un obstáculo para ayudarte. </p>
                        </li>
                    </ul>
                    <br>
                    <h2 class="h2-title"><b>¡No esperes más! Empeña tu auto sin dejarlo</b>
                    </h2>
                    <p class="regular-text">Estás a solo un clic de la solución financiera que necesitas sin sacrificar tu movilidad ni tu estilo de vida. Aprovecha las ventajas que nuestro servicio exclusivo de préstamos con garantía de auto ofrece.</p>
                </div>

            </div>

        </div>
        <SolicitaloBannerS2 />
    </div>
</template>

<script>
import { useMeta } from 'vue-meta';
import BannerSection from '@/components/Landings/BannerSection.vue';
import BeneficiosIbancarCarousel from '@/components/PrestamoGarantiaAuto/BeneficiosIbancarCarousel.vue';
import SolicitaloBannerS2 from '@/components/Landings/SolicitaloBannerS2.vue';
import PerksComponent from '../components/PerksComponent.vue';


export default {
    name: 'PrestamosGarantiaAutoCdmx',
    components: {
        BannerSection,
        BeneficiosIbancarCarousel,
        SolicitaloBannerS2,
        PerksComponent
    },
    setup() {
        useMeta(
            {
                title: 'Préstamos con garantía de auto en CDMX: rápidos y seguros | IBANCAR México',
                meta: [
                    {
                        name: 'robots',
                        content: 'index'
                    },
                    {
                        name: 'description',
                        content: 'Préstamos con garantía de auto en CDMX. Obtén hasta $120,000 MXN sin dejar tu auto. 100% online y seguro y en menos de 24 horas en Ciudad de México.'
                    },
                    {
                        name: 'keywords',
                        content: 'prestamos en cdmx, prestamos en la ciudad de mexico, prestamos personales en la ciudad de mexico, empeños cdmx'
                    }
                ],
                link: [
                    { href: 'https://ibancar.mx/prestamos-garantia-auto-cdmx', rel: 'alternate', hreflang: 'es-MX' }
                ]
            }
        )
    },

    data() {
        return {
            ventajas: [
                {
                    image: 'image12.svg',
                    title: 'Ejecutivo personalizado',
                },
                {
                    image: 'solicitud-en-linea.svg',
                    title: 'Proceso simple sin salir de casa',
                },

                {
                    image: 'prestamos-48-hrs.svg',
                    title: 'Hasta $120,000 en 24H',
                },
                {
                    image: 'proceso-simple.svg',
                    title: 'Aceptamos personas en Buró.',
                }

            ]
        }
    }
}
</script>

<style scoped lang="scss">
@import 'bootstrap/scss/_functions.scss';
@import 'bootstrap/scss/_variables.scss';
@import 'bootstrap/scss/_mixins.scss';


.image-container {
    text-align: center;
    margin: 3rem 0rem;

    img {
        max-height: 400px;
    }
}

.body-container {
    margin-top: 4.5rem;
    min-height: calc(100vh - 115px);
}

@include media-breakpoint-up(md) {
    .body-container {
        margin-top: 8.5rem;
    }
}

.ibancar-election {
    margin: 1rem 2rem 0rem 2rem;

    p {
        color: #004680;
        text-align: center;
        font-family: 'Montserrat-Bold';
        font-size: 1.3rem;
        font-style: normal;
        line-height: normal;
        margin: 1.5rem 0rem;
    }
}

.text-container {
    width: 80%;
    margin-left: auto;
    margin-right: auto;
    font-size: 20px;
    text-align: justify;
}

.regular-text {
    font-family: "Montserrat";
    font-size: 20px;
    line-height: 30px;
}

.bold-text {
    font-family: "Montserrat-Bold";
}

.text-orange {
    color: $orange;
}

.text-blue {
    color: $blue;
}

.text-black {
    color: $black;
}

.text-underline {
    text-decoration: underline;
}


.btn-solicitar {
    a {
        &:hover {
            text-decoration: none;
        }
    }
}

// Image
.image {
    bottom: 0;
    right: 0;
    width: 30%;
    z-index: -1;
}

@include media-breakpoint-down(md) {
    .text-container {
        width: 90%;
    }

    .regular-text {
        line-height: 1.5;
    }

    ul {
        padding-inline-start: 20px;
    }

    ol {
        padding-inline-start: 20px;
    }

    p,
    h1,
    h2,
    h3,
    h4 {
        text-align: left;
    }
}

@include media-breakpoint-between(md, lg) {
    .regular-text {
        font-size: 16px;
    }

    .subtitle {
        font-size: 16px;
    }
}

@include media-breakpoint-down(sm) {
    .title {
        font-size: 23px;
        line-height: 25px;
    }

    .h2-title {
        font-size: 18px;
        line-height: 20px;
    }

    .h3-title {
        font-size: 16px;
        line-height: 15px;
    }

    .regular-text {
        font-size: 14px !important;
    }

    .section-container {
        margin-top: 1.5rem;
    }
}
</style>